import { useEffect, useId, useRef } from "react";
import ReactCodeInput from "react-code-input";

import FieldWrapper from "../FieldWrapper";

import * as Styled from "./styles";
import { CodeInputProps } from "./types";

const CodeInput: React.FC<CodeInputProps> = ({
  error,
  value,
  fields = 4,
  ...props
}) => {
  const name = useId();
  const codeInputRef = useRef<ReactCodeInput>(null);

  useEffect(() => {
    if (!codeInputRef.current) {
      return;
    }

    // Fix for controlled input
    codeInputRef.current.setState({
      value,
      input: Array.from({ ...(value?.split("") || []), length: fields }).map(
        (v) => v || ""
      ),
    });
  }, [value, fields]);

  return (
    <FieldWrapper
      {...{ error }}
      controller={
        <Styled.CodeInput
          ref={codeInputRef}
          {...{ name, fields, value, ...props }}
        />
      }
    />
  );
};

export default CodeInput;
